import { render } from "./creditprestige.vue?vue&type=template&id=9089d14e&bindings={\"navigate\":\"props\"}"
import script from "./creditprestige.vue?vue&type=script&lang=js"
export * from "./creditprestige.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./creditprestige.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script